import {
  ApiPrefixes,
  ApiSlugs,
  CodeVerificationDto,
  TokenVaultResetUserPasswordDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../api-caller.service';

export class TokenVaultsUserRegistrationConnector {
  private slug = ApiSlugs.USER_REGISTRATIONS;

  constructor(
    private apiCaller: ApiCaller,
    private tokenVaultUrl: string,
    private prefix: string,
  ) {
    this.tokenVaultUrl = `${this.tokenVaultUrl}/${this.slug}`;
  }

  email = () => ({
    confirm: (code: CodeVerificationDto): Observable<boolean> =>
      this.apiCaller.postRequest<boolean>(this.prefix, `${this.tokenVaultUrl}/email/confirm`, code),
    sendNewConfirmation: (): Observable<boolean> =>
      this.apiCaller.postRequest<boolean>(this.prefix, `${this.tokenVaultUrl}/email/send-new-confirmation`),
  });

  mobileNumber = () => ({
    confirm: (smsCode: CodeVerificationDto): Observable<boolean> =>
      this.apiCaller.postRequest<boolean>(
        this.prefix,
        `${this.tokenVaultUrl}/mobile-number/confirm`,
        smsCode,
      ),
    sendNewVerfication: (): Observable<boolean> =>
      this.apiCaller.postRequest<boolean>(
        this.prefix,
        `${this.tokenVaultUrl}/mobile-number/send-new-verification`,
      ),
  });

  resetPassword = (tokenVaultResetUserPasswordDto: TokenVaultResetUserPasswordDto): Observable<boolean> =>
    this.apiCaller.postRequest<boolean>(
      ApiPrefixes.PUBLIC,
      `${this.tokenVaultUrl}/reset-password`,
      tokenVaultResetUserPasswordDto,
    );
}
